import React, { useState } from "react";
import { Container, Row, Col, Offcanvas, Navbar, Nav } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";

import NavbarLogo from "../Assets/Images/logo.png";

function Navbar_main() {
  const [showMenu, setShowMenu] = useState(false);

  const handleShowMenu = () => setShowMenu(true);
  const handleCloseMenu = () => setShowMenu(false);

  return (
    <>
      {/* 🔹 TOP HEADER */}
      <div className="top_header">
        <Container>
          <Row className="top_header_row align-items-center">
            <Col lg={5} md={6} xs={6}>
              <div className="top_header_number">
                <i className="bi bi-instagram"></i>
              </div>
            </Col>

            <Col lg={7} >
              <div className="top_header_main ">
                <a href="#">
                  Save ₹30 on all Orders <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* 🔹 BOTTOM HEADER */}
      <div className="bottom_header">
        <Navbar expand="lg" className="p-0">
          <Container className="nav_container">
            <div className="nav_left">
              <div className="mobile_toggle d-lg-none" onClick={handleShowMenu}>
                <i className="bi bi-list"></i>
              </div>

              <Navbar.Collapse className="d-none d-lg-flex">
                <Nav className="nav_center">
                  <Nav.Link  as={Link} to="/">Home</Nav.Link>
                  <Nav.Link as={Link} to="/about">About Us</Nav.Link>
                  <Nav.Link as={Link} to="/product">Products</Nav.Link>
                  <Nav.Link as={Link} to="/contact">Contact Us</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </div>
            <div className="nav_middle">
              <Navbar.Brand>
                <img src={NavbarLogo} alt="logo" className="nav_logo" />
              </Navbar.Brand>
            </div>
            <div className="nav_right">
              <a href="#"><i className="bi bi-search"></i></a>
              <a href="#"><i className="bi bi-person"></i></a>
              <a href="#"><i className="bi bi-cart"></i></a>
            </div>

          </Container>
        </Navbar>

        {/* 🔥 OFFCANVAS MENU */}
        <Offcanvas
          show={showMenu}
          onHide={handleCloseMenu}
          placement="start"
          className="bottom_header_offcanvas"
        >
          <Offcanvas.Header closeButton />
          <Offcanvas.Body>
            <Nav className="flex-column">
              <Nav.Link onClick={handleCloseMenu}>Home</Nav.Link>
              <Nav.Link onClick={handleCloseMenu}>About Us</Nav.Link>
              <Nav.Link onClick={handleCloseMenu}>Products</Nav.Link>
              <Nav.Link onClick={handleCloseMenu}>Contact Us</Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
}

export default Navbar_main;